<template>
  <div>
    <div class="shadow-card p-4">
      <div class="row p-2 mb-2">
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            'background-color': poll.user
              ? poll.user.url
                ? ''
                : ''
              : '#C997C5',
            border: '1px solid #ccc'
          }"
          :size="84"
          class="post-list-image text-capitalize"
          :src="poll.user ? poll.user.url : ''"
        ></a-avatar>
        <div class="ml-3 pb-0 pt-2 pl-0 " :style="{ 'font-size': '18px' }">
          <b>
            DoveMed Admin
          </b>
        </div>
      </div>

      <div class="post-image" v-if="poll.poll_attach">
        <img
          :src="
            poll.poll_attach.file ? poll.poll_attach.file : poll.poll_attach[0]
          "
          :style="{
            width: '100%',
            height: '100%',
            'object-fit': 'cover',
            'margin-top': '14px'
          }"
          alt
          class="mb-3"
        />
      </div>
      <b
        :style="{
          'font-size': '20px',
          'line-height': '30px',
          'white-space': 'pre-wrap',
          padding: '10px 0px'
        }"
        v-html="poll.poll_question"
      >
      </b>

      <div v-if="showPercent" class="row p-2 choice show">
        <div class="options" v-for="option in poll.choices" :key="option.id">
          <div class="option p-0">
            <div
              @click="choice = option.id"
              class="option"
              v-if="option.choice_vote"
              :style="{
                background: lighten(getPrimaryColor(), 50),
                maxWidth: option.choice_vote + '%'
              }"
            />
            <span class="poll-option">{{ option.poll_option }}</span>
            <span class="percentage"
              >{{ option.choice_vote.toFixed(0) }} %</span
            >
          </div>
        </div>

        <div class="d-flex justify-content-between w-100">
          <p :style="{ color: getPrimaryColor() }">
            Thank you for your Answer
          </p>
          <p>Total Votes : {{ poll.total_vote }}</p>
        </div>
      </div>
      <div v-else class="row p-2">
        <div class="options" v-for="option in poll.choices" :key="option.id">
          <div
            @click="submitPollResponse(option.id)"
            :style="{
              background: choice === option.id ? getPrimaryColor() : '',
              color: choice === option.id ? 'white !important' : ''
            }"
            class="option"
          >
            {{ option.poll_option }}
          </div>
        </div>
        <!-- <div class="w-100 d-flex justify-content-center">
          <a-button
            :disabled="choice === null || disabled"
            :loading="loading"
            class="dovemed-button primary-button font-white "
            :style="{ background: getPrimaryColor() }"
            @click="submitPollResponse()"
            >Submit</a-button
          >
        </div> -->
      </div>

      <div v-if="poll.tags" class="post__tags">
        <div
          v-for="(tag, index) in poll.tags.slice(0, 3)"
          :key="index"
          class="tags"
          :style="{
            color: getSecondaryColor(),
            background: getAlphaPrimaryColor()
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="poll.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in poll.tags.slice(3)"
                :key="index"
                :style="{
                  color: getSecondaryColor(),
                  background: getAlphaPrimaryColor()
                }"
              >
                #{{ tag }}
              </p>
            </template>
            <a-button
              :style="{
                background: getAlphaPrimaryColor(),
                color: getSecondaryColor(),
                padding: '2px'
              }"
              >+{{ poll.tags.length - 3 }}
            </a-button>
          </a-popover>
        </div>
      </div>
      <hr />
      <div class="d-flex" :style="{ gap: '50px' }">
        <!-- <div id="hugs" class="u-options" @click="react(poll, $event)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
            "
            :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Embrace ({{ poll.reaction.hugs }})
          </div>
        </div> -->
        <div id="likes" class="u-options" @click="react(poll, $event)">
          <font-awesome-icon
            size="1x"
            :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
            :style="{ color: reactions.likes ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Like ({{ poll.reaction.likes }})
          </div>
        </div>
        <!-- <div
          class="u-options"
          :style="{ display: !post.allow_comments ? 'none' : 'block' }"
        >
          <font-awesome-icon size="1x" :icon="['fal', 'comment-alt']" />
          <div class="posted-reactions-text">
            Comment ({{ post.comments_count }})
          </div>
        </div> -->
        <!-- <div id="favorites" class="u-options" @click="react(poll, $event)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.favorites ? ['fas', 'bookmark'] : ['fal', 'bookmark']
            "
            :style="{ color: reactions.favorites ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">Bookmark</div>
        </div> -->
        <div
          class="u-options"
          @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')"
        >
          <font-awesome-icon size="1x" :icon="['fal', 'share-alt']" />
          <div class="posted-reactions-text">Share</div>
        </div>
      </div>
    </div>
    <SharePostModal ref="sharePostModal" />
  </div>
</template>

<script>
import SharePostModal from "../../Modals/SharePost.vue";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import moment from "moment";
import { eventBus } from "../../../main";

const ResourceRepository = RepositoryFactory.get("resource");
const PostRepository = RepositoryFactory.get("posts");
export default {
  name: "AdminPollContent",
  props: {
    pollData: Object
  },
  data() {
    return {
      poll: [],
      loading: false,
      choice: null,
      reactions: {
        hugs: false,
        likes: false,
        favorites: false
      },
      posting: false,
      showPercent: false,
      disabled: false,
      adminImg: `https://mycircle-prod.s3.amazonaws.com/Dovemed.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZCNZWX7E2VSQY66U%2F20211119%2Fus-west-1%2Fs3%2Faws4_request&X-Amz-Date=20211119T120810Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=0a22e32e1395a47a20a59c4598ddb92b90af8fc9bf33c28755a3fcad4eb631e5`
    };
  },
  components: {
    SharePostModal
  },
  props: {
    pollData: Object
  },

  created() {
    this.poll = this.pollData;
    this.reactions.hugs = !!this.getReaction(1).length;
    this.reactions.likes = !!this.getReaction(2).length;
    this.reactions.favorites = !!this.getReaction(4).length;
    // this.poll.map(ele => (ele.poll_attach.file = this.adminImg));
  },
  filters: {
    updatedAt(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },

  methods: {
    getReaction(type) {
      let status = [];
      if (this.poll.my_reaction.length > 0) {
        status = this.poll.my_reaction.filter(reaction => {
          return reaction.reaction_type === type;
        });
      }
      return status;
    },
    handleBackToButton() {
      console.log(this.$router);
      if (this.pollData.user) {
        this.$router.push({ name: "ActivityHome" });
      } else {
        this.$router.push({ name: "ResourceList" });
      }
    },

    submitPollResponse(id) {
      this.choice = id;
      this.disabled = true;
      const data = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        poll: this.poll.id,
        choice: id
      };
      ResourceRepository.postPoll(data)
        .then(res => {
          this.$notification.success({
            message: "Success",
            description: "Poll submitted successfully."
          });
          eventBus.$emit("refresh-resource-view");
          this.showPercent = true;
          ResourceRepository.getpoll(
            this.poll.id,
            1,
            5,
            this.currentCircle.id
          ).then(res => {
            console.log(res, "new poll data");
            this.poll = res.data.data.data[0];
          });
        })
        .catch(err => console.error(err));
    },

    lighten(col, amt) {
      var usePound = false;

      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
    react(entity, event, comment = false) {
      // if (this.post.user[0].id === this.authUser.user.id) {
      //   return
      // }

      if (this.posting) {
        return;
      }
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
       */
      let path = event.path || (event.composedPath && event.composedPath());

      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5
      };

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
        POLL: 5
      };
      const type = event.target.id ? event.target.id : path[1]["id"];

      switch (type) {
        case "hugs":
          this.reactions.hugs
            ? this.deleteReaction(REACTION_TYPES.HUGS, type)
            : this.saveReaction(
                entity.id,
                REACTION_TYPES.HUGS,
                comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
              );
          break;
        case "likes":
          this.reactions.likes
            ? this.deleteReaction(REACTION_TYPES.LIKE, type)
            : this.saveReaction(
                entity.id,
                REACTION_TYPES.LIKE,
                comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
              );
          break;
        case "favorites":
          this.reactions.favorites
            ? this.deleteReaction(REACTION_TYPES.FAVORITE, type)
            : this.saveReaction(
                entity.id,
                REACTION_TYPES.FAVORITE,
                comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
              );
          break;
        case "flag":
          this.reactions.flag
            ? this.deleteReaction(REACTION_TYPES.FLAGED, type)
            : this.saveReaction(
                entity.id,
                REACTION_TYPES.FLAGED,
                comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
              );
          break;
        default:
          break;
      }
    },
    saveReaction(postId, reactionType, reactionOnType) {
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites"
      };
      this.posting = true;
      const payload = {
        reacted_on_type: reactionOnType,
        reacted_on_id: postId,
        user: this.authUser.user.id,
        reaction_type: reactionType
      };

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          this.posting = false;
          this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true;
          this.poll.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1;
          const index = this.poll.my_reaction.findIndex(
            rs => rs.reaction_type === reactionType
          );
          if (index >= 0) {
            this.poll.my_reaction.splice(index, 1);
          }
          this.poll.my_reaction.push(res.data.data);
        })
        .catch(err => {
          this.posting = false;
        });
    },
    deleteReaction(reactionId, type) {
      this.posting = true;
      const reactions = this.getReaction(reactionId);

      let ids = "";
      ids = reactions.map(reaction => {
        return reaction.id;
      });

      const user = JSON.parse(localStorage.getItem("user"));
      const headers = {
        Authorization: `Bearer ${user.user.token}`
      };
      this.$http
        .delete(
          `${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`,
          { headers }
        )
        .then(res => {
          this.reactions[type] = false;
          this.posting = false;
          if (this.poll.reaction[type] > 0) {
            this.poll.reaction[type] -= 1;
          }
        })
        .catch(err => {
          this.posting = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  font-size: 16px;
}
.last-update {
  font-size: 12px;
}
p.title {
  color: #333333;
  font-size: 20px;
  font-weight: bold;
}
.options {
  width: 100%;
  .option {
    position: relative;
    cursor: pointer;
    height: 55px;
    background-color: #f1f1f1;
    padding: 1rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    .poll-option {
      position: absolute;
      left: 1rem;
      top: 1rem;
    }
    .percentage {
      position: absolute;
      right: 20px;
      top: 1rem;
    }
  }
}
.back-button {
  color: "white ";
}
@media screen and (max-width: 581px) {
  .share-button {
    font-size: 14px;
  }
  .last-update {
    font-size: 10px;
  }
  .back-button {
    font-size: 12px;
  }
  .view-resource {
    font-size: 14px;
  }
}
.post__tags {
  margin: 10px;
  display: flex;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin: 5px;
  }
  .popover-button {
    margin: 5px;

    button {
      background: none;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/poll/adminPollCard.vue